import { createSlice } from "@reduxjs/toolkit";
import { fetchInsightsAsync } from "../insights/insightsSlice.js";
import { fetchNonEmptyInterviewsForProject } from "../interviews/interviewsSlice.js";
import { transcriptFragmentsAdapter } from "./transcriptFragmentsState.js";

/*
 * Slice
 */

const transcriptFragmentsSlice = createSlice({
  name: "transcriptFragments",
  initialState: transcriptFragmentsAdapter.getInitialState(),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchInsightsAsync.fulfilled, (state, action) => {
      transcriptFragmentsAdapter.addMany(
        state,
        action.payload.transcript_fragments,
      );
    });
    builder.addCase(
      fetchNonEmptyInterviewsForProject.fulfilled,
      (state, action) => {
        if (action.payload.matching_transcript_fragments) {
          transcriptFragmentsAdapter.upsertMany(
            state,
            action.payload.matching_transcript_fragments,
          );
        }
      },
    );
  },
});

export default transcriptFragmentsSlice.reducer;
